import { IValidationRule } from "@/types"

const reservationValidationRules: { [s: string]: IValidationRule } = {
    startDate: {
        required: true
    },
    endDate: {
        required: true
    },
    timeType: {
        required: true
    },
    duration: {
        required: true,
        type: "integer",
        min: 1
    },
    durationType: {
        required: true
    },
    purpose: {
        requiredRadio: true
    },
    language: {
        required: true
    },
    customer: {
        required: true
    },
    customerContactEmail: {
        type: "email"
    },
    coordinates: {
        required: true
    },
    price: {
        required: true,
        type: "decimal",
    },
    originCountryCode: {
        required: true,
    },
    targetCountryCode: {
        required: true,
    },
    interestPercentage: {
        type: "decimal",
        min: 0,
        max: 100,
    },
    netValue: {
        required: true,
        type: "decimal",
        gt: 0,
    },
    machineInsuranceExcess: {
        type: "decimal",
        min: 0,
    },
    workingDaysPerMonth: {
        required: true,
        type: "integer",
        min: 1,
        max: 31
    }
}

export default reservationValidationRules
